/* istanbul ignore file */
import { Video } from '@lumapps/play-core/api/types';
import { Block, LegacyWidgetProperties } from '@lumapps/widget-base/types';

export interface BlockPlayType extends Block {
    type: 'BlockPlay';
}

export interface WidgetPlayVideoIds {
    video?: {
        id: Video['id'] | undefined;
    };
    /**
     * We keep the videoId until we are sure that all widgets have
     * been reverted back to video.id
     */
    videoId?: string;
}

export enum MetadataItems {
    author = 'author',
    description = 'description',
    publicationDate = 'publication_date', // snake_case for translation keys
    title = 'title',
    views = 'views',
}

export const AllVideoMetadata = { ...MetadataItems };

export type VisibleMetadata = Array<keyof typeof AllVideoMetadata>;

export interface WidgetPlayPropertiesType extends WidgetPlayVideoIds {
    order?: VisibleMetadata;
    style?: LegacyWidgetProperties['style'];
}

export interface VisibleMetadataObject {
    author: boolean;
    description: boolean;
    publicationDate: boolean;
    title: boolean;
    views: boolean;
}
